<div class="login">
    <div class="login-form">
        <h2>Signup</h2>
        <div class="alert alert-danger" *ngIf = "res">
                <div>Registration Unsuccessful: {{res}}</div>
        </div>
        <form #f='ngForm' (ngSubmit) = "onRegisterSubmit(f)" action="#" class="pt-3 pb-3">
            <div class="input-group mb-3">
                <input type="text" required placeholder="First Name" ngModel name="firstName" #firstName = "ngModel" id="firstName">
            </div>
            <div class="alert alert-danger" *ngIf = "(firstName.touched && !firstName.valid) || (f.submitted && !firstName.touched)">
                <div *ngIf = "firstName.errors.required">First Name Is Required</div>
            </div>
            
            <div class="input-group mb-3">
                <input type="text" required placeholder="Last Name" ngModel name="lastName" #lastName = "ngModel" id="lastName">
            </div>
            <div class="alert alert-danger" *ngIf = "(lastName.touched && !lastName.valid) || (f.submitted && !lastName.touched)">
                <div *ngIf = "lastName.errors.required">Last Name Is Required</div>
            </div>
            
            <div class="input-group mb-3">
                <input type="text" required placeholder="email" ngModel name="email" #email = "ngModel" id="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$">
            </div>
            <div class="alert alert-danger" *ngIf = "(email.touched && !email.valid)||(f.submitted && !email.touched)">
                <div *ngIf = "email.errors.required">Email is Required</div>
                <div *ngIf = "email.errors.pattern">Email Should Contain "@"</div>
            </div>
            
            <div class="input-group mb-3">
                <input name='phone' required type="tel" placeholder="Mobile Number" ngModel #phone="ngModel" id = "phone">
            </div>
            <div class="alert alert-danger" *ngIf = "(phone.touched && !phone.valid)||(f.submitted && !phone.touched)">
                <div *ngIf = "phone.errors.required">Mobile Number Is Required</div>
            </div>
            
            <div class="input-group mb-3">
                <label for="dob">Date of Birth</label>
                <input type="date" required placeholder="Date Of Birth" ngModel name="dob" #dob = "ngModel" id="dob">
            </div>
            <div class="alert alert-danger" *ngIf = "(dob.touched && !dob.valid)||(f.submitted && !dob.touched)">
                <div *ngIf = "dob.errors.required">Date Of Birth Is Required</div>
            </div>
            
            <div class="input-group mb-3">
                <input [type]="fieldTextType ? 'text' : 'password'" required placeholder="password" ngModel name="password" #password = "ngModel" id="password" minlength = "6">
                <div class="input-group-append" style="cursor: pointer;">
                    <span class="input-group-text">
                        <i
                          class="fa"
                          [ngClass]="{
                            'fa-eye-slash': !fieldTextType,
                            'fa-eye': fieldTextType
                          }"
                          (click)="toggleFieldTextType()"
                        ></i>
                      </span>
                </div>
            </div>
            <div class="alert alert-danger" *ngIf = "(password.touched && password.invalid) || (password.touched && !password.valid)||(f.submitted && !password.touched) ">
                <div *ngIf="password.errors.minlength">Password must be at least 6 characters</div>
                <div *ngIf="password.errors.required">Password is required</div>
            </div>
            <p class="agreement mt-2 mb-2"><mat-checkbox [(ngModel)]="agreement" [ngModelOptions]="{standalone: true}"> I agree to Neprose's <a routerLink="/tos">terms & condition</a> and <a routerLink="/privacy-policy">privacy policy</a>.</mat-checkbox></p>
            <input *ngIf="!dataLoading" type="submit" [disabled]="!(f.valid && agreement)" value="Signup" class="mt-1">
            <button *ngIf="dataLoading" disabled class="mt-1 no-border-button"><mat-spinner [diameter]="'27'"></mat-spinner></button>
        </form>
    </div>
    <p class="login-register">Already have an account?<br /> <a class="site-title" [routerLink]="['/login']">Login</a> to add your property!</p>
</div>